import { soilChargeEngineeringProjectConstants } from "../constants";

const initState = {
  query: {},
  list: {}
};

export const soilChargeEngineeringProjects = (state = initState, action) => {
  switch (action.type) {
    case soilChargeEngineeringProjectConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          loading: true
        }
      };
    case soilChargeEngineeringProjectConstants.GET_ALL_SUCCESS:
      return {
        ...state,
        query: {
          queryCondition: action.queryCondition,
          total: action.total,
          queryResult: action.items
        }
      };
    case soilChargeEngineeringProjectConstants.GET_ALL_FAILURE:
      return {
        ...state,
        query: {
          queryFail: action.error
        }
      };
    case soilChargeEngineeringProjectConstants.RESET_ALL_SUCCESS:
      return {
        ...state,
        query: {}
      };
    case soilChargeEngineeringProjectConstants.GET_LIST_REQUEST:
      return {
        ...state,
        list: {
          loading: true,
          listItems: null,
          getListFail: null
        }
      };
    case soilChargeEngineeringProjectConstants.GET_LIST_SUCCESS:
      return {
        ...state,
        list: {
          loading: false,
          listItems: action.soilChargeEngineeringProjects,
          getListFail: null
        }
      };
    case soilChargeEngineeringProjectConstants.GET_LIST_FAILURE:
      return {
        ...state,
        list: {
          loading: false,
          listItems: null,
          getListFail: action.error
        }
      };
    case soilChargeEngineeringProjectConstants.RESET_LIST_SUCCESS:
      return {
        ...state,
        list: {}
      };
    default:
      return state;
  }
};
